module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 68.13186813186813,
						"dataLabels": {
							"enabled": true,
							"format": "310",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.1978021978022,
						"dataLabels": {
							"enabled": true,
							"format": "283",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 58.681318681318686,
						"dataLabels": {
							"enabled": true,
							"format": "267",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.89010989010989,
						"dataLabels": {
							"enabled": true,
							"format": "227",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 35.16483516483517,
						"dataLabels": {
							"enabled": true,
							"format": "160",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.32158988256549,
						"dataLabels": {
							"enabled": true,
							"format": "1022",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.91418247515809,
						"dataLabels": {
							"enabled": true,
							"format": "940",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.75880758807588,
						"dataLabels": {
							"enabled": true,
							"format": "894",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.45438121047877,
						"dataLabels": {
							"enabled": true,
							"format": "791",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.65853658536586,
						"dataLabels": {
							"enabled": true,
							"format": "594",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.32506887052342,
						"dataLabels": {
							"enabled": true,
							"format": "1712",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.0137741046832,
						"dataLabels": {
							"enabled": true,
							"format": "1543",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.48760330578513,
						"dataLabels": {
							"enabled": true,
							"format": "1479",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.55371900826447,
						"dataLabels": {
							"enabled": true,
							"format": "1335",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.05785123966942,
						"dataLabels": {
							"enabled": true,
							"format": "963",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.02251466624386,
						"dataLabels": {
							"enabled": true,
							"format": "5930",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.9395909307119,
						"dataLabels": {
							"enabled": true,
							"format": "5231",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.68923418423974,
						"dataLabels": {
							"enabled": true,
							"format": "5026",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.6619628983669,
						"dataLabels": {
							"enabled": true,
							"format": "4772",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.584588552402096,
						"dataLabels": {
							"enabled": true,
							"format": "3758",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -31.868131868131865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.709677419354833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.653710247349819,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.981273408239703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -29.51541850220264,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.678410117434509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.023483365949124,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.893617021276597,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.521252796420578,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -24.905183312262956,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.67493112947658,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.871495327102808,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.147764095917039,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.73630831643002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.865168539325847,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.977485333756139,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.787521079258012,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.918944752437392,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.053720652606442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.248952221290864,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=455"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1107"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1815"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6307"
			}
		],
		"dataTable": {
			"< 30": [
				455,
				310,
				283,
				267,
				227,
				160
			],
			"30–39": [
				1107,
				1022,
				940,
				894,
				791,
				594
			],
			"40–49": [
				1815,
				1712,
				1543,
				1479,
				1335,
				963
			],
			"≥ 50": [
				6307,
				5930,
				5231,
				5026,
				4772,
				3758
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 168
// module chunks = 0